import { Note } from 'src/models/note';

import { Callback } from 'src/util/query/models/Callback';

export class NoteCallback extends Callback<Note> {
	public constructor(private readonly setNote: (note: Note | null) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Note): void => {
		this.setNote(successResponse);
	};
}
